@import "../../global/normalize.css";

/**
  * @prop --ic-z-index-dialog: z-index of dialog 
  */

:host {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100% !important;
  background: rgb(0 0 0 / 60%);
  z-index: var(--ic-z-index-dialog);
  opacity: 0;
}

:host(.ic-dialog-fade-in) {
  opacity: 1;
}

:host(.disable-height-constraint) {
  background: none;
  justify-content: unset;
  align-items: unset;
}

.dialog.disable-height-constraint {
  max-height: none;
  position: relative;
}

.dialog.disable-height-constraint .content-area {
  overflow-y: visible;
}

@media (prefers-reduced-motion: no-preference) {
  :host {
    transition: opacity var(--ic-easing-transition-slow);
  }

  .dialog {
    transform: translateY(-3rem);
    transition: transform 1000s;
  }

  :host(.ic-dialog-fade-in) .dialog {
    transform: translateY(0);
    transition: transform var(--ic-easing-transition-slow);
  }
}

:host(.ic-dialog-hidden) {
  display: none;
}

.dialog {
  background-color: var(--ic-dialog-background);
  color: var(--ic-dialog-text-primary);

  --ic-typography-color: var(--ic-dialog-text-primary);

  border: var(--ic-space-1px) solid var(--ic-dialog-border);
  border-radius: var(--ic-border-radius);
  padding: var(--ic-space-xs) 0 var(--ic-space-md);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow-x: visible;
}

.small {
  width: 50%;
  max-width: 25rem;
  min-height: 11rem;
  max-height: 70vh;
}

.medium {
  width: 70vw;
  max-width: 44rem;
  min-height: 12.5rem;
  max-height: 70vh;
}

.large {
  width: 90vw;
  max-width: 62.5rem;
  min-height: 12.5rem;
  max-height: 90vh;
}

.heading-area {
  display: flex;
  margin-bottom: var(--ic-space-xs);
  padding: 0 var(--ic-space-md);
}

.heading {
  overflow-wrap: break-word;
}

.close-icon {
  margin-left: auto;
}

.close-icon > svg {
  color: var(--ic-dialog-clear-button);
}

.content-area {
  padding: 0 var(--ic-space-md);
  margin: 0;
  overflow-y: auto;
}

#dialog-content {
  margin-bottom: var(--ic-space-sm);
}

#dialog-content ::slotted(ic-typography) {
  overflow-wrap: break-word;
}

#dialog-content ::slotted(*) {
  position: relative;
}

.dialog-controls {
  margin-top: auto;
  padding: var(--ic-space-xs) var(--ic-space-md) 0;
  display: flex;
  justify-content: flex-end;
  gap: var(--ic-space-md);
}

.dialog-control-button {
  width: fit-content;
}

.backdrop {
  overflow-y: auto;
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(0 0 0 / 60%);
  z-index: var(--ic-z-index-dialog);
  padding-top: 16px;
  padding-bottom: 16px;
}

.heading ic-typography {
  --ic-typography-color: var(--ic-dialog-text-primary);
}

.label ic-typography {
  --ic-typography-color: var(--ic-dialog-label);
}

@media (min-width: 800px) {
  .large:not(.disable-width-constraint) > .content-area {
    width: 75%;
  }
}

@media (max-width: 576px) {
  .dialog {
    width: 100vw;
    height: 100vh;
    max-width: none;
    max-height: none;
    box-sizing: border-box;
  }

  .backdrop {
    padding: 0;
  }

  .dialog.disable-height-constraint {
    height: auto;
    min-height: 100vh;
  }
}

@media (max-width: 364px) {
  .dialog-control-button {
    width: unset;
  }
}
